import {KeyString} from "../Models/ApiModels";
//eslint-disable-next-line no-extend-native
Date.prototype.toJSON = function (useLocal?: boolean) {
    //use custom implementation for better performance
    const useZeroDate = this.getFullYear() < 1000;
    let year = this[useLocal ? 'getFullYear' : 'getUTCFullYear']().toString();
    let month = (this[useLocal ? 'getMonth' : 'getUTCMonth']() + 1).toString();
    let day = this[useLocal ? 'getDate' : 'getUTCDate']().toString();
    let hh = this[useLocal ? 'getHours' : 'getUTCHours']().toString();
    let mm = this[useLocal ? 'getMinutes' : 'getUTCMinutes']().toString();
    let ss = this[useLocal ? 'getSeconds' : 'getUTCSeconds']().toString();
    if (useZeroDate) {
        year = '0001';
        month = '1';
        day = '1';
        hh = this.getHours().toString();
        mm = this.getMinutes().toString();
        ss = '0';
    }
    if (month.length === 1)
        month = '0' + month;
    if (day.length === 1)
        day = '0' + day;
    if (hh.length === 1)
        hh = '0' + hh;
    if (mm.length === 1)
        mm = '0' + mm;
    if (ss.length === 1)
        ss = '0' + ss;

    return `${year}-${month}-${day}T${hh}:${mm}:${ss}${useZeroDate || useLocal ? '' : 'Z'}`;
};

type FormatPatternData = {
    regExp: RegExp,
    patterns: string[]
};

export default class DateTimeService {
    static ISO_8601_date: RegExp = /^\d{4}-\d\d-\d\d(T\d\d:\d\d(:\d\d)?(\.\d+)?(([+-]\d\d:\d\d)|Z)?)?$/i;
    static regExpDateMask: RegExp = /(YYYY|YY|MMMM|MM|M|DD|D|dd|d|HH|H|mm|ss|SSS)/g;
    static monthNames: string[] = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    static weekDayNames2Letters: string[] = ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'];

    static fromString(value: string): Date {
        return new Date(Date.parse(value));
    }

    static addDays(date: Date, days: number): Date {
        return new Date(date.getTime() + days * 24 * 60 * 60 * 1000);
    }

    static isValidDate(d: Date) {
        return !isNaN(d.getTime());
    }

    static compare(d1: Date, d2: Date): number {
        return d1.getTime() - d2.getTime();
    }

    static format(date: Date, format: string = 'DD.MM.YYYY'): string {
        let result = format;
        result = result.replace(this.regExpDateMask, (match: string) => {
            switch (match) {
                case 'DD':
                    return date.getUTCDate() < 10 ? '0' + date.getUTCDate() : date.getUTCDate().toString();
                case 'D':
                    return date.getUTCDate().toString();
                case 'dd':
                    let dayOfWeek = date.getUTCDay() - 1;
                    if (dayOfWeek < 0) {
                        dayOfWeek = 6;
                    }
                    return this.weekDayNames2Letters[dayOfWeek];
                case 'MMMM':
                    return this.monthNames[date.getUTCMonth()];
                case 'MM':
                    return date.getUTCMonth() + 1 < 10 ? '0' + (date.getUTCMonth() + 1).toString() : (date.getUTCMonth() + 1).toString();
                case 'M':
                    return (date.getUTCMonth() + 1).toString();
                case 'YYYY':
                    return date.getUTCFullYear().toString();
                case 'YY':
                    return date.getUTCFullYear().toString().substr(-2);
                case 'HH':
                    return date.getUTCHours() < 10 ? '0' + date.getUTCHours() : date.getUTCHours().toString();
                case 'H':
                    return date.getUTCHours().toString();
                case 'mm':
                    return date.getUTCMinutes() < 10 ? '0' + date.getUTCMinutes() : date.getUTCMinutes().toString();
                case 'ss':
                    return date.getUTCSeconds() < 10 ? '0' + date.getUTCSeconds() : date.getUTCSeconds().toString();

                default:
                    return match;
            }
        });
        return result;
    }

    static formatLocal(date: Date, format: string = 'DD.MM.YYYY'): string {
        let result = format;
        result = result.replace(this.regExpDateMask, (match: string) => {
            switch (match) {
                case 'DD':
                    return date.getDate() < 10 ? '0' + date.getDate() : date.getDate().toString();
                case 'D':
                    return date.getDate().toString();
                case 'dd':
                    let dayOfWeek = date.getDay() - 1;
                    if (dayOfWeek < 0) {
                        dayOfWeek = 6;
                    }
                    return this.weekDayNames2Letters[dayOfWeek];
                case 'MMMM':
                    return this.monthNames[date.getMonth()];
                case 'MM':
                    return date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1).toString() : (date.getMonth() + 1).toString();
                case 'M':
                    return (date.getMonth() + 1).toString();
                case 'YYYY':
                    return date.getFullYear().toString();
                case 'YY':
                    return date.getFullYear().toString().substr(-2);
                case 'HH':
                    return date.getHours() < 10 ? '0' + date.getHours() : date.getHours().toString();
                case 'H':
                    return date.getHours().toString();
                case 'mm':
                    return date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes().toString();
                case 'ss':
                    return date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds().toString();

                default:
                    return match;
            }
        });
        return result;
    }

    static now(): Date {
        return new Date();
    }

    static utcFromLocal(date: Date): Date {
        return this.parse(this.formatLocal(date), 'DD.MM.YYYY');
    }

    static date(year: number, month: number, day: number): Date {
        return new Date(Date.UTC(year, month, day, 0, 0, 0, 0));
    }

    static zeroDate(date?: Date): Date {
        const zeroDate = new Date('0001-01-01');
        if (date) {
            zeroDate.setHours(date.getHours(), date.getMinutes(), 0, 0);
        }
        return zeroDate;
    }

    static today(): Date {
        let today = new Date();
        return DateTimeService.date(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate());
    }

    static endOfDay(date:Date): Date {
        date.setHours(0, 0, 0, 0);
        return DateTimeService.addMs(DateTimeService.addDays(date, 1), -1);
    }

    static getMinutesFromMidnight(date: Date): number {
        return date.getHours() * 60 + date.getMinutes();
    }

    static todayLocal(): Date {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        return today;
    }

    static startOfDay(date: Date): Date {
        return this.date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
    }

    static startOfHour(date: Date): Date {
        date.setMinutes(0, 0, 0);
        return date;
    }

    static toJSONLocal(date: Date): string {
        return date.toJSON(true);
    }

    static addTime(date: Date, hours: number, minutes?: number): Date {

        let offset = hours * 60 * 60 * 1000;
        if (minutes) {
            offset += minutes * 60 * 1000;
        }

        return new Date(date.getTime() + offset);
    }

    static addMs(date: Date, ms: number): Date {

        return new Date(date.getTime() + ms);
    }

    static readonly patternCache: { [key: string]: FormatPatternData } = {};

    static readonly patternsToRegex: KeyString = {
        YYYY: '(\\d{4})',
        MMMM: '(\\S+)',
        MM: '(\\d{2})',
        M: '(\\d{1,2})',
        DD: '(\\d{2})',
        D: '(\\d{1,2})',
        HH: '(\\d{2})',
        H: '(\\d{1,2})',
        mm: '(\\d{2})',
        ss: '(\\d{2})',
        SSS: '(\\d{3})'
    };

    static getNanDate(): Date {
        return new Date(NaN);
    }

    private static _parseSafeInteger(value: string, maxValue: number) {
        const parsedPart = parseInt(value, 10);
        if (isNaN(parsedPart) || parsedPart < 0 || !Number.isInteger(parsedPart)) {
            throw new Error('Failed parse ' + value + ' exception, expected format [0-9]');
        }
        if (parsedPart > maxValue) {
            return NaN;
        }

        return parsedPart;
    }

    static parse(value: string, format: string): Date {
        if (typeof value !== 'string') return this.getNanDate();

        let year = 1;
        let month = 0;
        let day = 1;
        let hour = 0;
        let minute = 0;
        let second = 0;
        let milliseconds = 0;
        let pattern = DateTimeService.patternCache[format];

        if (!pattern) {
            const patterns: string[] = [];

            const regexpText = format.replace(this.regExpDateMask, (_, pattern) => {
                patterns.push(pattern);
                return DateTimeService.patternsToRegex[pattern];
            });

            const regexp = new RegExp(regexpText);
            pattern = {
                regExp: regexp,
                patterns: patterns
            };
            DateTimeService.patternCache[format] = pattern;
        }

        const match = value.match(pattern.regExp);
        if (match) {
            for (let i = 1; i < match.length; i++) {
                const foundValue = pattern.patterns[i - 1];
                const valuePart = match[i];

                switch (foundValue) {
                    case 'YYYY':
                        year = this._parseSafeInteger(valuePart, 9999);
                        break;
                    case 'M':
                    case 'MM':
                        month = this._parseSafeInteger(valuePart, 12) - 1;
                        break;
                    case 'MMMM':
                        month = this.monthNames.indexOf(valuePart);
                        if (month === -1) throw new Error('Invalid month name');
                        break;
                    case 'D':
                    case 'DD':
                        day = this._parseSafeInteger(valuePart, 31);
                        break;
                    case 'H':
                    case 'HH':
                        hour = this._parseSafeInteger(valuePart, 23);
                        break;
                    case 'mm':
                        minute = this._parseSafeInteger(valuePart, 59);
                        break;
                    case 'ss':
                        second = this._parseSafeInteger(valuePart, 59);
                        break;
                    case 'SSS':
                        milliseconds = this._parseSafeInteger(valuePart, 999);
                        break;
                }
            }
        } else {
            return this.getNanDate();
        }

        const newDate = new Date(Date.UTC(year, month, day, hour, minute, second, milliseconds));
        const newDateDay = newDate.getUTCDate();
        if (newDateDay === day) {
            return newDate;
        }

        return this.getNanDate();
    }

}
